var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArr002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 65,
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.956 17.953 5.66 35.88.457 32.89l16-27.858L19.113.408l2.573 4.672 15.5 28.14-5.256 2.894-9.974-18.108-.148 16.517-.022 2.474-.066 7.422-.177 19.791-6-.053.177-19.792.066-7.421.023-2.474z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr002);
export default __webpack_public_path__ + "static/media/arr-002.a33bd78a9cd86eef6414deef692b450f.svg";
export { ForwardRef as ReactComponent };